import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Sender } from '@sendbird/chat/message';
import { AppService } from 'src/app/app.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { defaultAvatarPc } from 'src/app/shared/interfaces/settings.interface';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from 'src/app/shared/service/connected-dialog';
import { SendbirdChatService } from '../../sendbird-chat.service';
import { ChatProfileComponent } from '../chat-profile/chat-profile.component';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [CSButtonComponent],
  selector: 'app-chat-avatar',
  templateUrl: './chat-avatar.component.html',
  styleUrls: ['./chat-avatar.component.scss'],
})
export class ChatAvatarComponent {
  @Input() sender!: Sender;

  avatarUrl: string = '';

  constructor(
    private matConnectedDialog: MatConnectedDialog,
    private appService: AppService,
    public sendbirdChatService: SendbirdChatService,
  ) {}

  ngOnChanges() {
    const selAvatar: defaultAvatarPc | undefined = this.appService.avatarList.find(
      (v: defaultAvatarPc) => v.idx === this.sender?.plainProfileUrl,
    );

    if (selAvatar?.processedUrl) {
      this.avatarUrl = selAvatar?.processedUrl;
    } else {
      this.avatarUrl = this.appService.avatarList[0]?.processedUrl || '';
    }
  }

  async handleClickAvatar() {
    if (this.sendbirdChatService.checkNeedToLogin()) {
      return;
    }

    this.matConnectedDialog.open(ChatProfileComponent, {
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
      data: {
        sender: this.sender,
        avatarUrl: this.avatarUrl,
      },
    });
  }
}
